<template>
  <div class="v3-widget v3-panel v3-scorering" v-testid="testid">
    <div v-if="label" class="v3-panel-head"><h3 v-testid="testid + '-title'">{{ label }}</h3></div>
    <div class="v3-scorering-body">
      <span class="v3-scorering-ring">
        <svg :width="box" :height="box" :viewBox="'0 0 ' + box + ' ' + box" aria-hidden="true">
          <circle :cx="mid" :cy="mid" :r="r" fill="none" stroke="var(--v3-border-soft)" :stroke-width="sw"></circle>
          <circle
            :cx="mid"
            :cy="mid"
            :r="r"
            fill="none"
            :stroke="colour"
            :stroke-width="sw"
            stroke-linecap="round"
            :stroke-dasharray="on + ' ' + (circ - on)"
            :transform="'rotate(-90 ' + mid + ' ' + mid + ')'"
          ></circle>
        </svg>
        <span class="v3-scorering-n" :style="{ color: colour }" v-testid="testid + '-value'">{{ shown }}</span>
      </span>
      <div v-if="caption" class="v3-scorering-cap">{{ caption }}</div>
    </div>
  </div>
</template>

<script>
// New-portal (v3) ScoreRing — a 0–100 quality/score ring (prototype V3ScoreRing,
// scaled up for a panel). Colour thresholds: ≥75 green, ≥40 amber, else rose.
// Presentation-only. Sibling: rm-portal-beta ScoreRingWidget.vue.
export default {
  name: "cLandingV3ScoreRing",
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  data() {
    return { box: 88, mid: 44, r: 38, sw: 9 };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3ScoreRing";
    },
    circ() {
      return 2 * Math.PI * this.r;
    },
    label() {
      return this.definition.label === undefined ? "Quality" : this.definition.label;
    },
    caption() {
      return this.definition.caption || "";
    },
    pct() {
      const m = Number(this.definition.max) || 100;
      return Math.max(0, Math.min(100, ((Number(this.definition.score) || 0) / m) * 100));
    },
    on() {
      return (this.pct / 100) * this.circ;
    },
    shown() {
      return Math.round(Number(this.definition.score) || 0);
    },
    // Same quality tone bands as the V3ScoreMeter in DocListFull (design
    // parity): ≥80 green · ≥60 accent · else attn.
    colour() {
      const s = this.pct;
      return s >= 80 ? "var(--success-fg)" : s >= 60 ? "var(--v3-accent)" : "var(--v3-attn)";
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
